import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';
import * as systemActionTypes from '../../system/action-creator/actionTypes';

const email = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_EMAIL:
      return action.email;
    default:
      return state;
  }
}

const emailError = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_EMAIL_ERROR:
      return action.error;
    default:
      return state;
  }
}

const alertMessage = (state = "", action) => {
  switch(action.type){
    case systemActionTypes.SEND_OPT_SUCCESS:
    case systemActionTypes.SEND_OPT_FAILURE:
      return action.message;
    default:
      return state;
  }
}

const openDialog = (state = false, action) => {
  switch(action.type){
    case actionTypes.TOGGLE_ALIERT_DIALOG:
      return !state;
    case systemActionTypes.SEND_OPT_FAILURE:
    case systemActionTypes.SEND_OPT_SUCCESS:
      return true;
    default:
      return state;
  }
}

export default combineReducers({
  email,
  alertMessage,
  openDialog,
  emailError
});

const getCurrentState = state => state.forgetPassword;

export const getEmail = state => getCurrentState(state).email;

export const getEmailError = state => getCurrentState(state).emailError;

export const getAlertMessage = state => getCurrentState(state).alertMessage;

export const getOpenDialog = state => getCurrentState(state).openDialog;